import React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../../../redux/selectors/resources';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../../../shared/routing';

export const CardReplenishment = () => {
  const content = useSelector(contentSelector());
  const nav = useNavigation();

  const handlePressHistoryLink = () => nav.navigate(Screens.TransportCardReplenishmentHistory);

  return <View content={content} onPressHistoryLink={handlePressHistoryLink} />;
};
